import { Switch, TextField } from "@mui/material";
import { ChangeEvent } from "react";
import StyledTableCell from "./TableCell";

export interface IModelVarInputCell {
  onChangeInput: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  isInputType: boolean;
  modelVarValue: number;
}

const ModelVarInputCell = ({
  onChangeInput,
  isInputType,
  modelVarValue
}: IModelVarInputCell) => {
  return (
    <StyledTableCell align="center">
      {isInputType && (
        <TextField
          type="number"
          variant="outlined"
          value={modelVarValue}
          InputProps={{
            inputProps: {
              min: 0
            }
          }}
          onChange={onChangeInput}
          required
        />
      )}
      {!isInputType && (
        <Switch
          checked={modelVarValue > 0}
          onChange={onChangeInput}
          color="info"
        />
      )}
    </StyledTableCell>
  );
};

export default ModelVarInputCell;
